/**
 * IUISurvey implementation based on an ICustomSurvey object
 */
import * as Utils from "../../Utils";
export default class CustomUISurvey {
  constructor(survey) {
    this.comment = "";
    this.ratingIndex = -1;
    this.showPrompt = survey.showPrompt;
    this.showEmailRequest = Utils.isBoolean(survey.showEmailRequest) ? survey.showEmailRequest : false;
    this.survey = survey;
  }
  getPromptQuestion() {
    return this.survey.promptQuestion;
  }
  getTitle() {
    return this.survey.title;
  }
  getPromptYesButtonText() {
    return this.survey.promptYesButtonText;
  }
  getPromptNoButtonText() {
    return this.survey.promptNoButtonText;
  }
  getRatingValuesAscending() {
    return this.survey.ratingValuesAscending;
  }
  getRatingQuestion() {
    return this.survey.ratingQuestion;
  }
  getCommentQuestion() {
    return this.survey.commentQuestion;
  }
  getInterceptTitle() {
    return undefined;
  }
  getInterceptQuestion() {
    return undefined;
  }
  getInterceptUrl() {
    return undefined;
  }
  setValues(ratingIndex, comment) {
    this.comment = comment;
    if (this.isRatingIndexValid(ratingIndex)) {
      this.ratingIndex = ratingIndex;
    } else {
      this.ratingIndex = -1;
    }
  }
  getJsonElements() {
    let result = {};
    result.comment = this.comment;
    result.rating = this.getNormalizedRatingScore();
    result.survey = {
      surveyId: this.getCampaignId()
    };
    return result;
  }
  getSurveyType() {
    return this.survey.surveyType;
  }
  getCampaignId() {
    return this.survey.campaignId;
  }
  getId() {
    return this.getCampaignId();
  }
  isRatingIndexValid(index) {
    return index >= 0 && index < this.survey.ratingValuesAscending.length;
  }
  getNormalizedRatingScore() {
    if (!this.isRatingIndexValid(this.ratingIndex)) {
      return -1;
    }
    if (this.survey.isZeroBased) {
      return this.ratingIndex / (this.survey.ratingValuesAscending.length - 1);
    } else {
      return (this.ratingIndex + 1.0) / this.survey.ratingValuesAscending.length;
    }
  }
}